import React, { Component } from 'react'
import './verify.css'

class Verify extends Component {
  state = {
    supportButton: null
  }
  componentWillMount = () => {
    this.props.setAlert(
      'Due to high volume of new registrants, your verification email may be delayed.', 
      'If you don’t receive your verification email in a minute or two, please let us know in the chat window below.', 
      '',
      '')
  }
  render() {
    return <div className="registerBox">
        <div className="title">Verify your email</div>
        <p className="almost-done">You're almost done! We just sent a link to</p>
        <p className="almost-done-email">{localStorage.getItem('last_submitted_email')}</p>
      </div>
  }
}

export default Verify



// WEBPACK FOOTER //
// ./src/verify.js